import React, { useEffect, useState } from "react";
import moment from "moment";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  CardBody,
  Form,
  InputGroup,
} from "react-bootstrap";
import DynamicPagination from "../../components/DynamicPagination ";
import {
  IconStar,
  IconStarFilled,
  IconEye,
  IconThumbDown,
  IconSearch,
  IconThumbUp,
} from "@tabler/icons-react";
import { API_ENDPOINTS } from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import View_FeedbackDetail from "./ViewFeedbackDetail/View_FeedbackDetail";
import useIdleLogout from "../../hooks/useIdleLogout";

const ReviewListing = () => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchClicked, setIsSearchClicked] = useState(false);

  const options = [
    { label: "Fast And Timely Service", value: "liked_fast_service" },
    { label: "Easy And Smooth Process", value: "liked_easy_process" },
    { label: "Good Value For Money", value: "liked_good_value" },
    { label: "High Product/Service Quality", value: "liked_high_quality" },
    { label: "Excellent Support After Purchase", value: "liked_support_after" },
  ];

  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    order: [],
    isStatusUpdate: false,
  });
  const [isCardOpen, setIsCardOpen] = useState({
    show: false,
    auto_id: null,
    primary_email: null,
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    user: null,
    message: "",
  });

  const { data: feedbacks, postData: fetchFeedbacks } = usePostRequest(
    API_ENDPOINTS.FEEDBACK_LISTING
  );

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handleLimitChange = (selectedLimit) => {
    setPage(1);
    setLimit(selectedLimit);
  };

  useEffect(() => {
    fetchFeedbacks({
      page,
      limit,
      search: searchTerm || "",
    });
  }, [page, limit, isSearchClicked]);

  const handleSearchInputChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearch = () => {
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleCloseCard = () => {
    setIsCardOpen({ show: false });
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    setPage(1);
    setIsSearchClicked((prev) => !prev);
  };

  const handleViewClick = (row) => {
    setIsCardOpen({
      show: true,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row?.Order?.order_id}`;
    window.history.pushState(null, "", newUrl);
  };

  useIdleLogout();

  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => {
      const starValue = index + 1;
      return (
        <span
          key={starValue}
          style={{
            color: starValue <= rating ? "#FFA500" : "#6C7A91",
            fontSize: "1.2rem",
            marginRight: "2px",
          }}
        >
          {starValue <= rating ? (
            <IconStarFilled size={16} />
          ) : (
            <IconStar size={16} />
          )}
        </span>
      );
    });
  };

  return (
    <>
      <View_FeedbackDetail />

      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title">Customer Reviews</h2>
          </div>
        </div>
      </div>
      <Card className="mb-3">
        <CardBody>
          <Form
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <Row className="align-items-end">
              <Col md={9}>
                <Form.Label>Search</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                  />
                </InputGroup>
              </Col>
              <Col md={3}>
                <div className="d-flex gap-2">
                  <Button
                    className="w-100"
                    variant="warning"
                    onClick={handleSearch}
                  >
                    Apply Filters
                  </Button>
                  <Button
                    className="w-100"
                    variant="outline-secondary"
                    onClick={handleClearSearch}
                  >
                    Clear Filters
                  </Button>
                </div>
              </Col>
              <Form.Text>Search by Order ID</Form.Text>
            </Row>
          </Form>
        </CardBody>
      </Card>

      <Row>
        {feedbacks?.data?.map((feedback, index) => (
          <Col md={4} key={index}>
            <Card className="mb-3" onClick={() => handleViewClick(feedback)} style={{ cursor: "pointer" }}>
              <Card.Body>
                <div className="d-flex gap-2 align-items-center mb-2 position-relative">
                  <b>Order ID:</b>
                  <p className="mb-0">{feedback?.Order?.order_id}</p>
                  <div
                    class="avatar bg-gray-50 text-gray-50-fg"
                    style={{ position: "absolute", right: "0", top: "0" }}
                  >
                    <IconEye />
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center mb-2">
                  <b>Order Rating:</b>
                  <span
                    className="mb-0"
                    style={{ color: "var(--tblr-orange)" }}
                  >
                    {feedback.order_rating}/10
                  </span>
                </div>
                <div className="d-flex gap-2 align-items-center mb-2">
                  <b>Product Quality:</b>
                  <span className="mb-0">
                    {renderStars(feedback?.product_quality_rating)}
                  </span>
                </div>

                <div className="d-flex gap-2 align-items-center mb-2">
                  <b>Logistics:</b>
                  <span className="mb-0">
                    {renderStars(feedback?.logistics_rating)}
                  </span>
                </div>

                <div className="mb-3">
                  <b className="mb-1 d-block">What did they like?</b>
                  <p className="mb-0">
                    {options
                      .filter((opt) => feedback[opt.value] === 1)
                      .map((opt) => (
                        <Badge
                          key={opt.value}
                          className="badge bg-blue-lt me-1"
                        >
                          {opt.label}
                        </Badge>
                      ))}
                  </p>
                </div>

                <div className="d-flex gap-2 align-items-center">
                  <b>Would Recommend:</b>
                  {feedback.would_recommend === 1 ? (
                    <span className="badge bg-green btn-pill">
                      <IconThumbUp size={16} className="me-1" />
                      Yes
                    </span>
                  ) : (
                    <span className="badge bg-red btn-pill">
                      <IconThumbDown size={16} className="me-1" />
                      No
                    </span>
                  )}
                </div>

                <div className="bg-light p-2 mt-2 rounded">
                  <strong>Additional Feedbacks:</strong>
                  <Card.Text style={{ fontSize: "0.9rem" }}>
                    {feedback?.additional_feedback}
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {feedbacks?.data?.length > 0 && (
        <DynamicPagination
          totalPages={feedbacks?.pagination?.totalPages}
          currentPage={page}
          onPageChange={handlePageChange}
          limitPerPage={limit}
          onLimitChange={handleLimitChange}
        />
      )}
    </>
  );
};

export default ReviewListing;
